// Storefront entry loaded on every page. Pages work without it; keep it small.
document.documentElement.classList.add("js")

const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches

// Header gets a solid background once the page scrolls (it is transparent over the home hero).
const header = document.querySelector<HTMLElement>("[data-header]")
if (header) {
  const update = () => header.classList.toggle("is-scrolled", window.scrollY > 16)
  update()
  addEventListener("scroll", update, { passive: true })
}

// Mobile menu is a <details>; add Escape, close on navigation and lock page scroll while open.
const menu = document.querySelector<HTMLDetailsElement>("[data-menu]")
if (menu) {
  menu.addEventListener("toggle", () => document.documentElement.classList.toggle("menu-open", menu.open))
  menu.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => (menu.open = false)))
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || !menu.open) return
    menu.open = false
    menu.querySelector("summary")?.focus()
  })
}

// Slow fade-in for blocks below the fold. Blocks already visible are never hidden, so nothing flickers.
if (!reducedMotion && "IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.remove("is-pending")
        observer.unobserve(entry.target)
      }
    },
    { rootMargin: "0px 0px -6% 0px" },
  )
  for (const block of document.querySelectorAll<HTMLElement>("[data-reveal]")) {
    if (block.getBoundingClientRect().top < innerHeight) continue
    block.classList.add("is-pending")
    observer.observe(block)
  }
}

// Cart quantities submit on change; the "recalculate" button is only needed without JS.
for (const field of document.querySelectorAll<HTMLSelectElement>("select[data-autosubmit]")) {
  field.addEventListener("change", () => field.form?.requestSubmit())
}
for (const button of document.querySelectorAll<HTMLElement>("[data-cart-update]")) button.hidden = true
